"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultLocale = exports.getDirFromLocale = exports.languageIcons = exports.languageLabels = exports.locales = void 0;
var logo_png_1 = __importDefault(require("../assets/logo.png"));
exports.locales = ['en', 'ar'];
exports.languageLabels = {
    en: 'English',
    ar: 'عربي',
};
exports.languageIcons = {
    en: '🇬🇧',
    ar: '🇸🇦',
};
var getDirFromLocale = function (locale) { return (locale === 'ar' ? 'rtl' : 'ltr'); };
exports.getDirFromLocale = getDirFromLocale;
var getDefaultLocale = function () {
    var defaultLocale = ((window.navigator.languages && window.navigator.languages[0]) || window.navigator.language).slice(0, 2);
    if (!(defaultLocale in exports.languageLabels)) {
        defaultLocale = 'en';
    }
    return defaultLocale;
};
exports.getDefaultLocale = getDefaultLocale;
var defaultLang = (0, exports.getDefaultLocale)();
var defaultSettings = {
    version: 1,
    logo: logo_png_1.default,
    locale: defaultLang,
    direction: (0, exports.getDirFromLocale)(defaultLang),
    isMobile: false,
};
exports.default = defaultSettings;
